import { useId, useState } from 'react';

type PetWhatIsThisProps = {
  definition: string;
  /** Align with dollar-prefixed inputs (same left edge as the input box). */
  alignWithDollarInput?: boolean;
  /** Sit directly under a full-width select (same left edge as the box). */
  underSelect?: boolean;
};

function PetWhatIsThis({
  definition,
  alignWithDollarInput = false,
  underSelect = false,
}: PetWhatIsThisProps) {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  const content = (
    <div className="pet-what-is-wrap">
      <button
        type="button"
        className="pet-what-is-btn"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        What is this?
      </button>
      {open && (
        <p id={panelId} className="pet-definition-panel" role="region">
          {definition}
        </p>
      )}
    </div>
  );

  if (alignWithDollarInput) {
    return (
      <div className="pet-dollar-input-wrap pet-what-is-under-field">
        <span className="pet-dollar-prefix pet-dollar-prefix--spacer" aria-hidden="true">
          $
        </span>
        {content}
      </div>
    );
  }

  if (underSelect) {
    return <div className="pet-what-is-under-select">{content}</div>;
  }

  return content;
}

export default PetWhatIsThis;
